module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('center', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showEmailSpinner,
      "color": "#aab0b3"
    }
  }), _vm._v(" "), (_vm.showEmailSpinner) ? _c('p', [_vm._v(_vm._s(_vm.labels.GENERATING_EMAIL))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-header"
  }, [_c('button', {
    staticClass: "filter-toggler btn btn-transparent btn-size-32 active",
    attrs: {
      "title": _vm.isFiltersActive ? _vm.labels.CLOSE_FILTER : _vm.labels.OPEN_FILTER,
      "type": "button"
    },
    on: {
      "click": _vm.toogleFilters
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-filter-o"
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-sm btn-link btn-reset pull-right",
    attrs: {
      "title": _vm.labels.RESET_ALL_FILTERS,
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetFilters($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.RESET))]), _vm._v(" "), _c('span', {
    staticClass: "filter-search-icon mmk-icon mmk-icon-search"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quickSearchText),
      expression: "quickSearchText"
    }],
    staticClass: "search pull-left noCommitOnEnter",
    attrs: {
      "placeholder": _vm.labels.SEARCH,
      "autofocus": "autofocus"
    },
    domProps: {
      "value": (_vm.quickSearchText)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.makeSearch($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quickSearchText = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.hasQuickSearch) ? _c('button', {
    staticClass: "btn btn-transparent btn-size-16 btn-clear",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetQuickSearch
    }
  }, [_vm._v("x")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "filter-body small"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('div', {
    staticClass: "filter-category"
  }, [_c('div', {
    staticClass: "panel-collapse collapse in"
  }, [_c('div', {
    staticClass: "filter-category-body small"
  }, [_c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.languageOptions,
      "label": "code",
      "placeholder": _vm.labels.LANGUAGE
    },
    model: {
      value: (_vm.languageFilterValue),
      callback: function($$v) {
        _vm.languageFilterValue = $$v
      },
      expression: "languageFilterValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.userStatusOptions,
      "placeholder": _vm.labels.STATUS
    },
    model: {
      value: (_vm.userStatusValue),
      callback: function($$v) {
        _vm.userStatusValue = $$v
      },
      expression: "userStatusValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.groupsFilterOptions,
      "placeholder": _vm.labels.GROUPS
    },
    model: {
      value: (_vm.groupsFilterValue),
      callback: function($$v) {
        _vm.groupsFilterValue = $$v
      },
      expression: "groupsFilterValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper",
    staticStyle: {
      "margin-bottom": "4px"
    }
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.userImplementOptions,
      "placeholder": _vm.labels.OU
    },
    model: {
      value: (_vm.userImplementationValue),
      callback: function($$v) {
        _vm.userImplementationValue = $$v
      },
      expression: "userImplementationValue"
    }
  })], 1), _vm._v(" "), (_vm.userImplementationValue.length == 0) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.labels.REQUIRED))]) : _vm._e()]), _vm._v(" "), (_vm.isCurrentUserMMPWM) ? _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.mmpwmLocations,
      "placeholder": _vm.labels.PHYSICAL_LOCATION,
      "disabled": _vm.userImplementationValue.length == 0 || _vm.userImplementationValue[0].value != 'mmpwm'
    },
    model: {
      value: (_vm.physicalLocation),
      callback: function($$v) {
        _vm.physicalLocation = $$v
      },
      expression: "physicalLocation"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserMMPWM_Admin && _vm.userImplementationValue.length > 0 && _vm.userImplementationValue[0].value == 'mmpwm') ? _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('div', {
    staticClass: "select2-wrapper"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "options": _vm.userTypes,
      "placeholder": _vm.labels.USER_TYPE
    },
    model: {
      value: (_vm.userType),
      callback: function($$v) {
        _vm.userType = $$v
      },
      expression: "userType"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-sm first-filter-element"
  }, [_c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "#",
      "disabled": _vm.userImplementationValue.length == 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.makeSearch($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.SEARCH))])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "records",
    attrs: {
      "infinite-scroll-disabled": "loadMoreBusy",
      "infinite-scroll-distance": "10"
    }
  }, [_c('div', {
    staticClass: "sticky-box"
  }, [_c('div', {
    staticClass: "records-header"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-transparent btn-size-24 btn-circle mr-1",
    attrs: {
      "title": _vm.fullView ? _vm.labels.SHOW_LESS : _vm.labels.SHOW_ALL_DETAILS,
      "type": "button"
    },
    on: {
      "click": _vm.toggleUserView
    }
  }, [_c('i', {
    staticClass: "mmk-icon",
    class: {
      'mmk-icon-unfold-less': _vm.fullView, 'mmk-icon-unfold-more': !_vm.fullView
    }
  })]), _vm._v(" "), (_vm.isCurrentUserAdmin) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('a', {
    staticClass: "btn min-width-96 btn-primary",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.labels.CREATE))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createDigiUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.DIGICREATE))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createSharePointUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.EXTRANETCREATE))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.createMMPDigiUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.labels.MMPCREATE))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_c('span', [_c('strong', {
    staticClass: "text-info"
  }, [_vm._v(_vm._s(_vm.filteredUsersCount))]), _vm._v(" of " + _vm._s(_vm.totalUsersCount) + " "), (_vm.userImplementationValue.length == 1) ? _c('span', [_vm._v("(" + _vm._s(_vm.userImplementationValue[0].label) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy),
      expression: "sortBy"
    }],
    staticClass: "form-control input-sm",
    staticStyle: {
      "width": "200px",
      "display": "inline-block"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.sortByChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "LastName"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_LASTNAME))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FirstName"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_FIRSTNAME))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Email"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_EMAIL))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Enabled"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_STATUS))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AccountName"
    }
  }, [_vm._v(_vm._s(_vm.labels.SORT_BY_ACCOUNT_NAME))])]), _vm._v(" "), _c('a', {
    staticClass: "mmk-icon ml-1",
    class: {
      'mmk-icon-sort-asc': _vm.sortOrder, 'mmk-icon-sort-desc': !_vm.sortOrder
    },
    attrs: {
      "title": _vm.sortOrder ? _vm.labels.ASCENDING : _vm.labels.DESCENDING,
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toogleSortOrder($event)
      }
    }
  })])])])]), _vm._v(" "), (_vm.loadFlags.settings && _vm.loadFlags.users) ? _c('div', {
    staticClass: "records-body"
  }, _vm._l((_vm.users), function(user, index) {
    return _c('div', {
      staticClass: "record-item card card-compressed"
    }, [_c('span', [_c('div', {
      staticClass: "card-body"
    }, [(user.IsActive) ? _c('div', {
      staticClass: "card-label card-label-success"
    }, [_vm._v(_vm._s(_vm.labels.ACTIVE))]) : _vm._e(), _vm._v(" "), (!user.IsActive) ? _c('div', {
      staticClass: "card-label card-label-default"
    }, [_vm._v(_vm._s(_vm.labels.INACTIVE))]) : _vm._e(), _vm._v(" "), (user.Locked) ? _c('div', {
      staticClass: "card-label card-label-warning"
    }, [_vm._v(_vm._s(_vm.labels.LOCKED))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "record-actions pull-left"
    }, [_c('button', {
      staticClass: "btn btn-transparent btn-size-24 btn-circle",
      class: {
        'collapsed': !user.viewModel.fullView
      },
      attrs: {
        "title": user.viewModel.fullView ? _vm.labels.SHOW_LESS : _vm.labels.SHOW_ALL_DETAILS,
        "type": "button"
      },
      on: {
        "click": function($event) {
          user.viewModel.fullView = !user.viewModel.fullView
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-chevron-bottom"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "record-content"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-2 break-all"
    }, [_c('b', [_c('span', [_vm._v(_vm._s(user.LastName))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-1 break-all"
    }, [_c('b', [_c('span', [_vm._v(_vm._s(user.FirstName))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 break-all"
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + user.Email
      }
    }, [_vm._v(_vm._s(user.Email))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 break-all"
    }, [_c('span', [_vm._v(_vm._s(user.Domain) + "\\" + _vm._s(user.AccountName))])]), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 text-right"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('a', {
      staticClass: "btn min-width-96 btn-primary",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.editUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.EDIT))]), _vm._v(" "), _vm._m(2, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [(_vm.isCurrentUserMMPWM && user.Locked && user.ExtensionAttribute6 === '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.unlockUser(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.UNLOCK))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserMMPWM && user.ExtensionAttribute6 === '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setPassword(user)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SET_PASSWORD))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && !user.IsActive && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.activateUser(user, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.ACTIVATE))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deactivateUser(user, $event)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.DEACTIVATE))])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMID')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMID')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMID', true)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_DIGI_NO_PASS))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMID', true)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasMMPDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMPDigi')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMPDigi')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasMMPDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'MMPDigi', true)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_MMP_NO_PASS))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'MMPDigi', true)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasSharePointGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'Sharepoint')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'Sharepoint')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.HasSharePointGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendWelcomeEmail(user, 'Sharepoint', true)
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_WELCOME_EMAIL_EXTRANET_NO_PASS))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getWelcomeEmailPreview(user, 'Sharepoint', true)
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'None')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_GENERIC))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'None')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.HasDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'MMID')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_DIGI))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'MMID')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.HasMMPDigiGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'MMPDigi')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_MMP))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'MMPDigi')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e(), _vm._v(" "), (_vm.isCurrentUserAdmin && user.IsActive && user.HasSharePointGroups && user.ExtensionAttribute6 !== '601') ? _c('li', {
      staticClass: "item-with-info"
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendForgotPasswordEmail(user, 'Sharepoint')
        }
      }
    }, [_vm._v(_vm._s(_vm.labels.SEND_FORGOT_PW_EMAIL_EXTRANET))]), _vm._v(" "), _c('a', {
      staticClass: "info-link",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.getForgotPasswordEmailPreview(user, 'Sharepoint')
        }
      }
    }, [_c('i', {
      staticClass: "mmk-icon mmk-icon-16 mmk-icon-info",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "fadeHeight"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (user.viewModel.fullView),
        expression: "user.viewModel.fullView"
      }],
      staticClass: "row"
    }, [_c('div', {
      staticClass: "user-details col-md-12"
    }, [_c('div', {
      staticClass: "row headers"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(_vm.labels.ORGANIZATION_UNIT))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_vm._v(_vm._s(_vm.labels.GROUPS))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(_vm.labels.COMPANY))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3 cell"
    }, [_vm._v(_vm._s(user.OrganizationUnit))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 cell"
    }, _vm._l((user.Groups), function(item) {
      return _c('div', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t")])
    })), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 cell"
    }, [_vm._v(_vm._s(user.Company))])]), _vm._v(" "), _c('div', {
      staticClass: "row headers",
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(_vm.labels.USER_TYPE))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9"
    }, [_vm._v(_vm._s(_vm.labels.CANONICAL_NAME))])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v(_vm._s(user.ExtensionAttribute6))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-9",
      staticStyle: {
        "word-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(user.CanonicalName))])])])])])], 1)])])])
  })) : _vm._e(), _vm._v(" "), _c('center', [_c('pulse-loader', {
    attrs: {
      "loading": _vm.showSpinner,
      "color": "#aab0b3"
    }
  })], 1), _vm._v(" "), _c('hr', {
    attrs: {
      "width": "400",
      "align": "center"
    }
  }), _vm._v(" "), (_vm.searchUsed) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.labels.LIST_END))]) : _vm._e(), _vm._v(" "), (!_vm.searchUsed) ? _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.labels.APPLY_FILTER_FOR_USERS))]) : _vm._e()], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "height": "auto",
      "scrollable": true,
      "width": "650px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "orange"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-default dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "mmk-icon mmk-icon-16 mmk-icon-chevron-bottom",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390e068e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UsersList/UsersList.vue
// module id = 181
// module chunks = 1